export function register() {
  console.warn("Service worker desativado nesta build.");
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .catch((error) => {
        console.error('Erro durante o desregistro do service worker:', error);
      });
  }
}
